module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-47.11277217.png";